import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const MenuList = React.forwardRef((_a, ref) => {
    var { className } = _a, attributes = __rest(_a, ["className"]);
    const classes = clsx(className, 'menu-list');
    return React.createElement("ul", Object.assign({}, attributes, { className: classes, ref: ref }));
});
MenuList.displayName = 'MenuList';
const MenuDivider = React.forwardRef((_a, ref) => {
    var { className } = _a, attributes = __rest(_a, ["className"]);
    const classes = clsx(className, 'menu-divider');
    return React.createElement("div", Object.assign({}, attributes, { className: classes, ref: ref }));
});
MenuDivider.displayName = 'MenuDivider';
const MenuGroup = React.forwardRef((_a, ref) => {
    var { className, title, children } = _a, attributes = __rest(_a, ["className", "title", "children"]);
    const classes = clsx(className, 'menu-group');
    return (React.createElement("div", Object.assign({}, attributes, { className: classes, ref: ref }),
        title && React.createElement(MenuHeader, null, title),
        children));
});
MenuGroup.displayName = 'MenuGroup';
const MenuHeader = React.forwardRef((_a, ref) => {
    var { className } = _a, attributes = __rest(_a, ["className"]);
    const classes = clsx(className, 'menu-header');
    return React.createElement("div", Object.assign({}, attributes, { className: classes, ref: ref }));
});
MenuHeader.displayName = 'MenuHeader';
const MenuItem = React.forwardRef((_a, ref) => {
    var { active, className, children, disabled, as: Component = 'li' } = _a, attributes = __rest(_a, ["active", "className", "children", "disabled", "as"]);
    const classes = clsx(className, 'menu-item', {
        'menu-item--disabled': disabled,
        'menu-item--active': active,
    });
    return (React.createElement(Component, Object.assign({}, attributes, { className: classes, role: 'menuitem', ref: ref }), children));
});
MenuItem.displayName = 'MenuItem';
export { MenuItem, MenuDivider, MenuList, MenuGroup, MenuHeader };
//# sourceMappingURL=index.js.map